import { Box, Checkbox, FormControlLabel, TextField } from "@mui/material";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  DETAIL_CARD_BACKGROUND,
  FREE_TEXT_MAX_ROWS,
  OPTION_CONTROL_SX,
  OPTION_ROW_SX,
  SOCIAL_SUB_FIELD_MIN_WIDTH_PX,
} from "../readmission-f2f-constant";
import {
  SocialSubField,
  SocialSubFieldGroup,
} from "../readmission-f2f-social-constant";

export interface SocialSubFieldCardsProps {
  groups: SocialSubFieldGroup[];
  subText: (field: SocialSubField) => string;
  subNone: (field: SocialSubField) => boolean;
  onSubTextChange: (field: SocialSubField, text: string) => void;
  onSubNoneToggle: (field: SocialSubField, on: boolean) => void;
}

/**
 * The detail card under a ticked social-history option: the sub-fields side by
 * side, each with its label, input and, where the backend has one, the
 * "not stated" checkbox beneath the input.
 */
const SocialSubFieldCards = ({
  groups,
  subText,
  subNone,
  onSubTextChange,
  onSubNoneToggle,
}: SocialSubFieldCardsProps) => (
  <>
    {groups.map((group) => (
      <Box
        key={group.option}
        sx={{ bgcolor: DETAIL_CARD_BACKGROUND, borderRadius: 1, p: 1.25 }}
        display="flex"
        flexDirection="column"
        gap={0.75}
      >
        <Text fontWeight="bold">{group.option}</Text>
        <Flex gap={2} flexWrap="wrap" alignItems="flex-start">
          {group.fields.map((field) => (
            <Box
              key={field.question}
              flex={1}
              minWidth={SOCIAL_SUB_FIELD_MIN_WIDTH_PX}
              display="flex"
              flexDirection="column"
              gap={0.5}
            >
              <Flex gap={1} alignItems="center">
                {field.label && (
                  <Text size={13} fontWeight="bold" sx={{ flexShrink: 0 }}>
                    {field.label}
                  </Text>
                )}
                <TextField
                  size="small"
                  fullWidth
                  multiline
                  maxRows={FREE_TEXT_MAX_ROWS}
                  placeholder={field.placeholder}
                  value={subText(field)}
                  disabled={subNone(field)}
                  inputProps={{ "aria-label": field.label || field.question }}
                  onChange={(e) => onSubTextChange(field, e.target.value)}
                />
              </Flex>
              {field.noneQuestion && (
                <FormControlLabel
                  sx={OPTION_ROW_SX}
                  control={
                    <Checkbox
                      size="small"
                      sx={OPTION_CONTROL_SX}
                      checked={subNone(field)}
                      onChange={(e) => onSubNoneToggle(field, e.target.checked)}
                    />
                  }
                  label={<Text size={13}>{field.noneQuestion}</Text>}
                />
              )}
            </Box>
          ))}
        </Flex>
      </Box>
    ))}
  </>
);

export default SocialSubFieldCards;
